import { render, staticRenderFns } from "./jumpPage.vue?vue&type=template&id=1d905cac&scoped=true&"
import script from "./jumpPage.vue?vue&type=script&lang=ts&"
export * from "./jumpPage.vue?vue&type=script&lang=ts&"
import style0 from "./jumpPage.vue?vue&type=style&index=0&id=1d905cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d905cac",
  null
  
)

export default component.exports